import { render, staticRenderFns } from "./mo-select.html?vue&type=template&id=8d05f436&external"
import script from "./mo-select.ts?vue&type=script&lang=ts&external"
export * from "./mo-select.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/2/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d05f436')) {
      api.createRecord('8d05f436', component.options)
    } else {
      api.reload('8d05f436', component.options)
    }
    module.hot.accept("./mo-select.html?vue&type=template&id=8d05f436&external", function () {
      api.rerender('8d05f436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-select/mo-select.vue"
export default component.exports